import React from "react";
import rehypeReact from "rehype-react";
import styled from "styled-components";
import Helmet from "../components/allpages/Helmet";
import Leerdoel from "../components/leerdoel/Leerdoel";
import Voorkennis from "../components/grammatica/Leerdoelen";
import Letop from "../components/allpages/Letop";
import ExtraTip from "../components/allpages/ExtraTip";
import Tip from "../components/allpages/Tip";
import Wrapper from "../components/allpages/Wrapper";

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    letop: Letop,
    t: Tip,
    x: ExtraTip
  }
}).Compiler;

const Title = styled.h1``;

const Post = styled.div`
  table {
    font-size: 0.9em;
    line-height: 100%;
    margin-bottom: 10px;
    margin-left: 2.4375em;
    width: 1%; /* auto-width for cells */
    white-space: nowrap; /* auto-width for cells */

    > tbody {
      > tr {
        > td {
          padding: 0px 1.875em 0.5em 0px;
        }
      }
    }
  }
`;

export default ({ data }) => {
  const post = data.markdownRemark;
  const { book, leerdoel, title } = post.frontmatter;
  return (
    <Wrapper>
      <Helmet data={data} />
      <Title>{title}</Title>
      <Leerdoel book={book} leerdoel={leerdoel} />
      {/* <Voorkennis book={book} leerdoel={leerdoel} /> */}
      <Post>{renderAst(post.htmlAst)}</Post>
    </Wrapper>
  );
};

export const query = graphql`
  query leerdoelQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      frontmatter {
        book
        leerdoel
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/leerdoel.js